import '../globals';

;(function ($, _, document, globalUrls) {
    'use strict';

    var pluginName = 'customerConditions';

    function Plugin(element) {
        this.element = $(element);
        this._name = pluginName;
        this.init();

        return this;
    }

    function setCookie(name, value) {
        document.cookie = name + "=" + value + ";path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    }

    $.extend(Plugin.prototype, {
        init: function () {
            var conditionsLong = this.element.find('.customer-conditions-long');
            var conditionsShort = this.element.find('.customer-conditions-short');

            setCookie('avency_nwd_account_show_conditions', '', -1);

            this.element.find('.alert-close-btn').on('click', function () {
                conditionsLong.addClass('d-none');
                conditionsShort.removeClass('d-none');
            });

            this.element.find('.customer-conditions-show-long-btn').on('click', function () {
                conditionsShort.addClass('d-none');
                conditionsLong.removeClass('d-none');
            })
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this));
            }
        });
    };
})(jQuery, _, document, globalUrls);
